import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/savings-goal',
  component: () => import('../../routes/SavingsGoal.svelte'),
  card: {
    id: 'savings-goal',
    title: 'Savings Goal',
    description: 'Set a financial target and track exactly how much you need to save monthly to reach it.',
    icon: 'savings',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/savings-goal',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Savings Goal Calculator – Monthly Savings & Retirement Savings Goals Calculator',
    description: 'Free savings goal calculator to plan monthly savings goals and calculate retirement savings goals. See how long it takes to reach your saving goal with our monthly savings goal calculator. Includes compound interest projections and progress tracking.',
  },
};

export default meta;
